import { Link } from "react-router-dom";
import css from './index.module.css';
import SEO from "@components/seo";

export default function NotFound () {
  return (
    <div className={css.container}>
        <SEO 
            title="Страница не найдена"
            description="Рыбный мир"
            ogUrl="https://рыбныимир.рф/"
        />

        <div className={css.component}>        
            <div>
                <h1>Потерялись?</h1>
                <a>Такой страницы не существует, давайте вернемся на главную</a>

                <div className={css.back}><Link to="/webapp">Вернуться на главную</Link></div>
            </div>
        </div>

    </div>
  )
}
